import { ApiPath } from '../api/ApiPath';
import { AsyncState, useAsync } from 'react-async';
import { Site } from '../sites/dto/Site';
import { useApiPromiseFn } from './useApiPromiseFn';

export function useSites(): AsyncState<Site[]> {
  return useAsync({
    promiseFn: useApiPromiseFn(ApiPath.Sites),
  });
}
